<div class="d-flex flex-row align-items-center cbm-item"
  [ngClass]=" {'cbm-item-selected' : selected }"
  (click)="clicked()">

  <div class="d-flex flex-row align-items-center" style="flex: 3;overflow: hidden;">
    <div class="d-flex flex-column align-items-center">
      <div class="cmb-circle"
        [ngClass]=" {'cmb-circle-selected' : selected }">
        @if (selected) {
          {{ selectionOrder == 0 ? '1st':'2nd' }}
        }
      </div>
      @if (selected) {
        <div class="cbm-choice">Choice</div>
      }
      @if (!selected) {
        <div class="cbm-choice" style="opacity: 0%;">Choice</div>
      }
    </div>
    <div class="cbm-detail" style="width: 100%;">
      @if (recommended) {
        <div class="detail-recommend">Top Recommended</div>
      }
      <div class="detail-name">{{ name }}</div>
      <div class="detail-tags">
        @for (item of tags; track item; let index = $index) {
          <div>{{ item }}</div>
        }
      </div>
      <div class="detail-view" (click)="viewDetail($event)">
        View Details & Reviews
      </div>
    </div>
  </div>
  <div style="flex:1;" class="pcab">
    {{ pcab }}
    <div class="_tooltip" style="width: 298px;right: 25px;">
      Category licensed by The Philippine Contractors Accreditation Board (PCAB) based on a contractor’s expertise, capitalization, etc.
    </div>
  </div>
  <div style="flex:auto;" class="star-container">
    <app-stardetails [rating]="rating" [reviews]="feedbacks.length" [starOnly]="false"></app-stardetails>
    <div class="_tooltip" style="width: 252px;right: 25px;">Star rating is based on customer reviews</div>
  </div>
</div>
